<template>
  <div class="container">
    <h1>Profile</h1>
    
    <div v-if="!user" class="loading">
      Loading profile...
    </div>
    
    <div v-else class="profile">
      <div class="user-info">
        <div class="avatar">
          <img v-if="user.telegram_photo_url" :src="user.telegram_photo_url" :alt="user.telegram_username">
          <div v-else class="avatar-placeholder">
            {{ getUserInitials() }}
          </div>
        </div>
        
        <div class="user-details">
          <h2>{{ getUserName() }}</h2>
          <p v-if="user.telegram_username" class="username">@{{ user.telegram_username }}</p>
        </div>
      </div>
      
      <div class="account-section">
        <h3>Account</h3>
        
        <div class="account-info">
          <div class="info-item">
            <span class="info-label">Member Since:</span>
            <span class="info-value">{{ formatDate(user.created_at) }}</span>
          </div>
        </div>
        
        <button class="btn logout-btn" @click="logout">
          Logout
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Profile',
  computed: {
    ...mapGetters('auth', ['user'])
  },
  methods: {
    ...mapActions('auth', ['logout']),
    getUserName() {
      if (!this.user) return ''
      
      if (this.user.telegram_first_name) {
        return this.user.telegram_first_name + (this.user.telegram_last_name ? ` ${this.user.telegram_last_name}` : '')
      }
      
      return this.user.telegram_username || this.user.username || 'User'
    },
    getUserInitials() {
      const name = this.getUserName()
      if (!name) return '?'
      
      return name
        .split(' ')
        .map(part => part[0])
        .join('')
        .toUpperCase()
        .substring(0, 2)
    },
    formatDate(dateString) {
      if (!dateString) return ''
      
      const date = new Date(dateString)
      return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },
    handleLogout() {
      this.logout()
      this.$router.push('/auth')
    }
  }
}
</script>

<style scoped>
h1 {
  margin-bottom: 24px;
  text-align: center;
}

.loading {
  text-align: center;
  padding: 20px;
  color: var(--tg-theme-hint-color);
}

.profile {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
}

.user-details h2 {
  margin-bottom: 4px;
}

.username {
  color: var(--tg-theme-hint-color);
}

.tokens-section, .account-section {
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 20px;
}

h3 {
  margin-bottom: 16px;
  font-size: 18px;
}

.tokens-card {
  background-color: var(--tg-theme-bg-color);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.token-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.token-item:last-child {
  border-bottom: none;
}

.token-item.total {
  font-weight: bold;
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.buy-tokens-btn {
  width: 100%;
  margin-top: 8px;
}

.account-info {
  background-color: var(--tg-theme-bg-color);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.logout-btn {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  color: var(--tg-theme-text-color);
}
</style> 